<template>
    <div>
        <div class="container-fluid">
            <dashboard-admin v-if="type === 'admin'"></dashboard-admin>
            <dashboard-coach v-if="type === 'coach'"></dashboard-coach>
        </div>
    </div>
</template>
<script>
    import DashboardAdmin from './Dashboards/Admins'
    import DashboardCoach from './Dashboards/Coachs'

    export default {
        components: {
            'dashboard-admin': DashboardAdmin,
            'dashboard-coach': DashboardCoach
        },
        data() {
            return {
                type: this.$store.getters.type
            };
        }
    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 20px;
    }


</style>
